// extracted by mini-css-extract-plugin
export default {"genericCard":"mt-z","inline":"nt-z","mastercard":"ot-z","discover":"pt-z","visa":"qt-z","amex":"rt-z","active":"st-z"};